import Vue from 'vue';

Vue.filter('pad', function (value, type, bit = 2, sign) {
  const str = value.toString();
  switch (type) {
    case 'start':
      return str.padStart(bit, sign);
    case 'end':
      return str.padEnd(bit, sign);
    default:
      return str
  }
})
